import DefaultRecordingImage from './DefaultRecordingImage';

export default DefaultRecordingImage;
